function normalizeTemplateRemark(value) {
  if (value === null || value === undefined) return ''
  return String(value).replace(/\s+/g, '')
}

function filterDuplicateTemplateRemark(forms, remark) {
  const source = Array.isArray(forms) ? forms : []
  const normalizedRemark = normalizeTemplateRemark(remark)
  if (!normalizedRemark) return source

  const duplicateIndex = source.findIndex(item => {
    if (!item || item.name !== 'Description') return false
    const props = item.props || {}
    return normalizeTemplateRemark(props.placeholder) === normalizedRemark
  })

  if (duplicateIndex < 0) return source
  return source.slice(0, duplicateIndex).concat(source.slice(duplicateIndex + 1))
}

module.exports = {
  filterDuplicateTemplateRemark,
  normalizeTemplateRemark
}
